    import Component from '../core/Component'
import enquire from 'enquire.js'
import { queries, CMS } from '../core/config'
import Scroll from '../services/Scroll'
import gsap from "gsap";

const STATES = {
    ACTIVE: 'is-active'
}

const text = {
    in: 'in'
}

export default class TagList extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            items: [],
            images: [],
            window: null,
            caption: null
        }

        this.move = {
            active: false,
            startX: 0,
            startY: 0,
            x: 0,
            y: 0
        }

        this.box = null
        this.windowBox = null
        this.items = []

        this.activeImage = 0
        this.activeItem = 0

        this.enquireHandler = {
            match: ::this.attach,
            unmatch: ::this.detach
        }

        const localization = this.element.dataset.localization ? JSON.parse(this.element.dataset.localization) : {}

        this.text = {
            ...text,
            ...localization
        }
    }

    prepare() {
        if (CMS) {
            return
        }

        enquire.register(queries.largeUp, this.enquireHandler)

        this.ref.items.map($link => {
            $link.addEventListener('focus', this.handleFocus)
        })
    }

    destroy() {
        enquire.unregister(queries.largeUp, this.enquireHandler)
    }

    attach() {
        this.element.addEventListener('mouseenter', this.handleMouseEnter)
        this.element.addEventListener('mouseleave', this.handleMouseLeave)
        this.element.addEventListener('mousemove', this.handleMouseMove)

        this.ref.items.map($element => {
            $element.addEventListener('mouseenter', this.handleItemMouseEnter)
        })

        Scroll.on('scroll', this.handleScroll)
    }

    detach() {
        this.items = this.ref.items.map(($element, index) => {
            $element.removeEventListener('mouseenter', this.handleItemMouseEnter)
        })

        this.element.removeEventListener('mouseenter', this.handleMouseEnter)
        this.element.removeEventListener('mouseleave', this.handleMouseLeave)
        this.element.removeEventListener('mousemove', this.handleMouseMove)

        Scroll.off('scroll', this.handleScroll)
    }

    handleScroll = (event) => {
        this.windowBox = this.ref.window.getBoundingClientRect()
        this.box = this.element.getBoundingClientRect()
    }

    handleItemMouseEnter = event => {
        this.switchImage(event.target)
        this.switchCaption(event.target)

        this.ref.items[this.activeItem].classList.remove(STATES.ACTIVE)
        event.target.classList.add(STATES.ACTIVE)

        this.activeItem = this.ref.items.indexOf(event.target)

        this.element.classList.add(STATES.ACTIVE)
        this.emit('enter')
    }

    switchImage($element) {
        let src = $element.dataset.src
        let srcset = $element.dataset.srcset
        let alt = $element.dataset.alt

        if (!src || !srcset || (src == this.ref.items[this.activeItem].dataset.src && this.ref.images[this.activeImage].classList.contains(STATES.ACTIVE))) {
            return
        }

        this.ref.images[this.activeImage].classList.remove(STATES.ACTIVE)
        this.activeImage = (this.activeImage == 0) ? 1 : 0
        this.ref.images[this.activeImage].classList.add(STATES.ACTIVE)

        this.ref.images[this.activeImage].src = src
        this.ref.images[this.activeImage].srcset = srcset

        this.ref.images[this.activeImage].alt = (alt) ? alt : ''
    }

    switchCaption($element) {
        if (!$element.querySelector('[data-number]') || !$element.querySelector('[data-name]')) {
            return
        }

        let number = $element.querySelector('[data-number]').innerHTML
        let name = $element.querySelector('[data-name]').innerHTML
        let caption = number + ' ' + this.text.in + ' ' + name

        this.ref.caption.innerHTML = caption
    }

    handleMouseEnter = event => {
        this.windowBox = this.ref.window.getBoundingClientRect()
        this.box = this.element.getBoundingClientRect()

        this.move = {
            startX: event.clientX,
            startY: event.clientY
        }

        let x = this.move.x - this.box.left - this.box.width/2
        let y = this.move.y - this.box.top - this.box.height/2

        this.move.active = true
    }

    handleMouseLeave = event => {
        this.move.active = false
        this.element.classList.remove(STATES.ACTIVE)
        this.emit('leave')
    }

    handleMouseMove = event => {
        if (!this.move.active) {
            return
        }

        this.move.x = event.clientX
        this.move.y = event.clientY

        requestAnimationFrame(this.render)
    }

    render = () => {
        gsap.to(this.ref.window, 1, {
            x: this.move.x - this.box.left - this.box.width/2,
            y: this.move.y - this.box.top - this.box.height/2,
            ease: "power3"
        })
    }
}